const IEMapService = require('../IEMapService');
const IResourceQueryService = require('../IResourceQueryService');
const IDistrictService = require('../IDistrictService');
const IResourceCatalogService = require('../IResourceCatalogService');
const IResourceMetaService = require('../IResourceMetaService');
const IResourceCurdService = require('../IResourceCurdService');
const IResourceDispatchService = require('../IResourceDispatchService');
const ITyphoonService = require('../ITyphoonService');
const TyphoonServiceImpl = require('./biz/TyphoonServiceImpl');
const ITyphoonForecastService = require('../ITyphoonForecastService');
const TyphoonForecastServiceImpl = require('./biz/TyphoonForecastServiceImpl');
const IGeocodeService = require('../IGeocodeService');
const GeocodeGaodeServiceImpl = require('./internet/GeocodeGaodeServiceImpl');
const GeocodeEgisServiceImpl = require('./internet/GeocodeEgisServiceImpl');
/**
 * @namespace
 * @memberOf G
 * @description 应急一张图服务
 */
const service = {
    IEMapService,
    IDistrictService,
    IResourceCatalogService,
    IResourceQueryService,
    IResourceMetaService,
    IResourceCurdService,
    IResourceDispatchService,
    ITyphoonService,
    TyphoonServiceImpl,
    ITyphoonForecastService,
    TyphoonForecastServiceImpl,
    IGeocodeService,
    GeocodeGaodeServiceImpl,
    GeocodeEgisServiceImpl
};
module.exports = service;